import { render, staticRenderFns } from "./PickupInfo.vue?vue&type=template&id=dfc72afc&scoped=true&"
import script from "./PickupInfo.vue?vue&type=script&lang=ts&"
export * from "./PickupInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PickupInfo.vue?vue&type=style&index=0&id=dfc72afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc72afc",
  null
  
)

component.options.__file = "PickupInfo.vue"
export default component.exports